import styled from '@emotion/styled'

export const OfferValue = styled.div`
  color: #818080;
  font-size: 0.875rem;
  padding: 0.25rem;
`
